package org.ksdfv.thelema.json

import kotlin.native.concurrent.ThreadLocal

/** @author zeganstyl */
@ThreadLocal
object JSON: IJSON {
    lateinit var proxy: IJSON

    override fun parseObject(text: String): IJsonObject = proxy.parseObject(text)

    override fun parseArray(text: String): IJsonArray = proxy.parseArray(text)

    override fun printArray(context: IJsonArray.() -> Unit): String = proxy.printArray(context)

    override fun printObject(context: IJsonObject.() -> Unit): String = proxy.printObject(context)

    override fun printObject(json: IJsonObjectIO): String = proxy.printObject(json)

    override fun printArray(json: IJsonArrayIO): String = proxy.printArray(json)
}